import {
	Box,
	Flex,
	ModuleWebIcon,
	ExpandIcon,
	Menu,
	MenuBoxButton,
	MenuItem,
	MenuList,
	ThemeIconSizeVariable,
	ThemeRadiusVariable,
	ThemeSpaceVariable,
	Placement,
} from "@caspeco/casper-ui-library";
import Flag from "react-flagkit";
import { IsoCountryCode } from "../../models/user";
import { useTranslation } from "react-i18next";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { Portal } from "@chakra-ui/react";
import { RefObject } from "react";

type CountrySelectorProps<
	T extends (keyof typeof IsoCountryCode | "Other")[] | (keyof typeof IsoCountryCode)[],
> = {
	countries: T;
	selectedCountry?: T[number];
	onSelect?: (value: T[number]) => void;
	disabled?: boolean;
	menuRef?: RefObject<HTMLElement | null>;
	menuPlacement?: Placement;
};

export const CountrySelector = <
	T extends (keyof typeof IsoCountryCode | "Other")[] | (keyof typeof IsoCountryCode)[],
>({
	countries,
	selectedCountry,
	onSelect,
	disabled,
	menuRef,
	menuPlacement,
}: CountrySelectorProps<T>) => {
	const { t } = useTranslation();

	const defaultSelectedCountry = !selectedCountry || selectedCountry === "None" ? "SE" : selectedCountry;
	const listItems = countries
		.filter((country) => country !== "None")
		.map((country, index) => {
			return (
				<MenuItem
					value={country}
					key={country}
					itemType="button"
					onClick={onSelect ? () => onSelect(country) : undefined}
				>
					<Box display={"flex"} gap={ThemeSpaceVariable.Small} alignItems={"center"}>
						{country === "Other" ? (
							<>
								<ModuleWebIcon />
								{country}
							</>
						) : (
							<>
								<Flag key={index} role="button" country={country} size={26} />
								{t(`country.${country}`)}
							</>
						)}
					</Box>
				</MenuItem>
			);
		});
	return (
		<>
			<Menu placement={menuPlacement} isLazy>
				<MenuBoxButton>
					<Flex direction={"row"} gap={ThemeSpaceVariable.Small}>
						{defaultSelectedCountry === "Other" ? (
							<ModuleWebIcon />
						) : (
							<Flag country={defaultSelectedCountry} />
						)}
						<ExpandIcon size={ThemeIconSizeVariable.Small} />
					</Flex>
				</MenuBoxButton>
				{!disabled ? (
					<Portal container={menuRef}>
						<MenuList
							overflow={"scroll"}
							maxHeight={"10rem"}
							minWidth={"fit-content"}
							borderRadius={ThemeRadiusVariable.Medium}
						>
							<Flex direction="column" gap={ThemeSpaceVariable.XSmall}>
								{listItems}
							</Flex>
						</MenuList>
					</Portal>
				) : null}
			</Menu>
		</>
	);
};
